import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Dialog from "../../components/Dialog";
import InputTextArea from "../../components/InputTextArea";
import IModalProps from "../../model/ModalProps";
import ButtonStyles from "../../styles/components/ButtonStyles";
import DialogStyles from "../../styles/components/DialogStyles";

const { BtnPrimary, DefaultButtonLink } = ButtonStyles;
const { StyledModalTitle, StyledContainerButton, StyledModalText } =
    DialogStyles;

function ModalRequestJustification(props: IModalProps) {
    const [justification, setJustification] = useState("");

    const isFormValid = Boolean(justification.trim());

    const handleSubmit = () => {
        if (isFormValid && props.onClose) {
            props.onClose({ success: true, data: justification });
        }
    };

    useEffect(() => {
        setJustification("");
    }, [props.open]);

    return (
        <Dialog openModal={props.open} onHide={props.onClose} size="width-600">
            <StyledModalTitle style={{ marginBottom: "0" }}>
                Justificativa da edição da agenda
            </StyledModalTitle>
            <StyledModalText className="mt-4 mb-4">
                Para salvar a edição da agenda, digite a justificativa abaixo.
            </StyledModalText>
            <Row>
                <Col>
                    <InputTextArea
                        label="Justificativa"
                        placeholder="Insira sua justicativa."
                        maxLength={500}
                        value={justification}
                        onChange={(event: any) =>
                            setJustification(event.target.value as string)
                        }
                        style={{ height: "95px" }}
                    />
                </Col>
            </Row>
            <StyledContainerButton>
                <BtnPrimary
                    disabled={!isFormValid}
                    onClick={() => handleSubmit()}
                >
                    Enviar
                </BtnPrimary>
            </StyledContainerButton>
            <StyledContainerButton>
                <DefaultButtonLink onClick={props.onClose}>
                    Cancelar
                </DefaultButtonLink>
            </StyledContainerButton>
        </Dialog>
    );
}

export default ModalRequestJustification;
